import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const issuerService = {
  getSCPIssuers, getPostCardIssuers
};

function getSCPIssuers() {
  return apiCall("GET", API_URLS.SMARTCARDPROCESS.GET_SCP_ISSUERS);
}

function getPostCardIssuers() {
  return apiCall("GET", API_URLS.ISSUERS.GET_ALL_ISSUERS);
}

